module.exports = __webpack_public_path__ + "static/f1-4b108f6b764f386101822738150a8cde.jpeg";